module.exports = __webpack_public_path__ + "static/img/RL-Collage1.e9ab18b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RL-Collage1.png
// module id = y59L
// module chunks = 0